export default "<p>\n  confirm-positive works!\n</p>\n";